export default __webpack_public_path__ + "static/media/Verizon.bb5c7a0f.png";